import { IntroComponent } from './components/intro/intro.component'
import { PageComponent } from './components/page/page.component'
import { ProjectPageComponent } from './components/project-page/project-page.component'
import { ProjectListComponent } from './components/project-list/project-list.component'
import { AboutComponent } from './components/about/about.component'
import { NetworkComponent } from './components/network/network.component'
import { MapComponent } from './components/map/map.component';
import { ContactComponent } from './components/contact/contact.component';
import { LinkedinFeedComponent } from './components/linkedin-feed/linkedin-feed.component'
import { IntroScreenComponent } from './components/intro-screen/intro-screen.component'


let Components = {
    'project' : ProjectPageComponent,
    'page' : PageComponent,
    'intro' : IntroComponent,
    'intro-screen' : IntroScreenComponent,
    'project-list' : ProjectListComponent,
    'about': AboutComponent,
    'network': NetworkComponent,
    'map': MapComponent,
    'contact': ContactComponent,
    'linkedin-feed': LinkedinFeedComponent
}

export { Components }